module.exports = __webpack_public_path__ + "static/media/bullet_icon.ea6b4bb7.svg";